import { cn } from '@/lib/tailwind'

interface AnimatedSectionProps {
  show: boolean
  children: React.ReactNode
  className?: string
  innerClassName?: string
  /** Optional animation delay for staggered reveals, e.g. "100ms" */
  delay?: string
}

/**
 * AnimatedSection - CSS-only expand/collapse wrapper using grid-template-rows technique.
 *
 * Smoothly expands from 0fr to 1fr with opacity transition.
 * Respects prefers-reduced-motion for instant transitions.
 *
 * Pattern: Always renders children (grid collapse + overflow-hidden handles visual hiding).
 */
export function AnimatedSection({
  show,
  children,
  className,
  innerClassName,
  delay,
}: AnimatedSectionProps) {
  return (
    <div
      className={cn(
        'grid transition-[grid-template-rows,opacity] duration-[250ms] ease-[cubic-bezier(0.16,1,0.3,1)] motion-reduce:transition-none',
        show ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0',
        className,
      )}
      style={delay ? { transitionDelay: delay } : undefined}
      aria-hidden={!show}
    >
      <div className={cn('overflow-hidden', innerClassName)}>{children}</div>
    </div>
  )
}
